import { createFileRoute } from '@tanstack/react-router';

import { ProductTypesPage, productTypesQueryOptions } from '@/features/dictionary';

export const Route = createFileRoute('/_authed/_active/org/catalog-setup/product-types/')({
  staticData: { tours: ['dictionary.product-types'] },
  loader: ({ context }) =>
    context.queryClient
      .query({ ...productTypesQueryOptions(), staleTime: 'static' })
      .catch(() => undefined),
  component: ProductTypesPage,
});
